import type { ThemeMode } from '@space-lib/styles/themes/enum'

export type Logos = {
  type: 'light' | 'dark'
  imageUrl: string
}

export type ButtonProps = {
  label?: string
  url?: string
}

export type Banners = {
  imageUrlWeb: string
  imageUrlMobile: string
  imageUrlMobileSmall?: string
  imageUrlWebSmall?: string
  url: string
  altText: string
  name: string
  buttons: ButtonProps[]
  hidden: boolean
  text?: string
  switchButton?: boolean
  switchText?: boolean
  switchUrl?: boolean
}

export enum ShowcaseOrientation {
  VERTICAL = 'VERTICAL',
  MODULE = 'MODULE',
  HORIZONTAL = 'HORIZONTAL'
}

export type Orientation = {
  global: ShowcaseOrientation
}

export type ApplicationPwaConfig = {
  switchPwa: boolean
  imageFileKeyIcon: string
  imageIconType: string
  backgroundColor: string
  imageFileKeyLogo: string
  imageUrlIcon: string
  imageUrlLogo: string
  imageUrlLogo1: string
}

export type Settings = {
  primaryColor: string
  logoAltText: string
  logos: Logos[]
  banners: Banners[]
  orientation?: Orientation
  labelMyPurchase?: string
  labelProductsOnSale?: string
  theme?: ThemeMode
  allowChangeTheme?: boolean
  showSections?: boolean
  application?: ApplicationPwaConfig[]
}

export type CustomDomains = {
  configStatus: string
  defaultFlag: boolean
  domain: string
}

export type Membership = {
  id: string
  name: string
  ownerUcode: string
  settings: Settings
  roles: string[]
  slug: string
  createDate: number
  ownerId?: number
  customDomains?: CustomDomains[]
  ownerHasMembershipChat?: boolean
  showcase?: boolean
  hasCommunity?: boolean
}
